<template>
    <footer class="pt2 pb2 bg--white text--black">
        <div class="container">
            <div class="pl1 pr1">
                <div class="grid-row grid-row--center">
                    <div class="grid-column span-half align--center-mobile">
                        <p class="mb0 bold mt1 mb1"><span class="block-on-mobile">&copy; Chefy, LLC</span><span class="hide-on-mobile"> &middot; </span><span class="block-on-mobile">{{currentYear}}</span><span class="hide-on-mobile"> &middot; all rights reserved</span></p>
                    </div>

                    <div class="grid-column span-half align--right">
                        <ul class="no-bullets list--inline mb0 align--center-mobile mt1 mb1">
                            <li class="mr1"><a href="https://medium.com/chefy-io" class="link"><img class="social-icon" src="../assets/medium.svg" alt="Medium"></a></li>
                            <li><a href="https://www.linkedin.com/company/chefy" class="link"><img class="social-icon" src="../assets/linkedin.svg" alt="LinkedIn"></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'app_footer',
    data () {
        return {
            currentYear: (new Date()).getFullYear()
        }
    }
}
</script>

<style lang="scss">
  @import '..//scss/main.scss'
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue